<div class="modal-header">
  <h4 class="modal-title text-center">{{ 'unvalidatedBaskets.modal.title' | translate }}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="handleClick(CLOSE)">&times;</button>
</div>
<mdb-icon fas icon="info" size="3x" class="text-primary text-center m-2"></mdb-icon>
<ul class="m-2">
  <li *ngFor="let message of messages" class="d-block w-100 mx-2 mb-1">
    {{ message }}
  </li>
</ul>
<div class="modal-footer justify-content-center flex-column">
  <button data-id-cypress="close-button" id="jhi-confirm-create-specialPlace" type="button" class="btn bary-btn btn-primary" (click)="handleClick(CLOSE)">
    <span jhiTranslate="unvalidatedBaskets.modal.actions.fermer">Confirmation</span>
  </button>
</div>
